/**
 * Tiny, dependency-free formatting/parsing helpers shared across the importer
 * (utils/ and components/import/ both consume these — keep this a leaf module so
 * either layer can import it without a cycle).
 */

/** Human-readable byte size, e.g. 1536 → "1.5 KB". */
export function fmtBytes(n) {
    if (!n) return "0 B";
    const u = ["B", "KB", "MB", "GB"];
    const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
    return `${(n / Math.pow(1024, i)).toFixed(i ? 1 : 0)} ${u[i]}`;
}

/** Lower-cased file extension without the dot, or "" if there is none. */
export function extensionOf(name) {
    const i = String(name || "").lastIndexOf(".");
    return i > 0 ? String(name).slice(i + 1).toLowerCase() : "";
}
